/* Joe Luxe scroll story engine — tiny, passive, rAF-driven.
   Sets --p (0 → 1) on every [data-jl-scroll] element while it is on screen.
   The value glides toward the scroll position (inertia) and is eased
   (smoothstep), so motion starts and lands softly. CSS turns --p into
   transform/opacity only. The loop sleeps when nothing is moving. */
(function () {
  /* Quiet scroll reveals for theme-section headings (opt-in by section key, no
     markup change): the heading fades up and rises with the scroll, same feel as
     the story headings. Transform/opacity only; --p defaults to 1 (fully shown). */
  var REVEAL = ['product_list_themegen', 'collections_joeluxe'];
  REVEAL.forEach(function (key) {
    var h = document.querySelector('[id$="__' + key + '"] h3');
    if (!h || h.hasAttribute('data-jl-scroll')) return;
    h.setAttribute('data-jl-scroll', '');
    h.setAttribute('data-jl-distance', '0.7');
    h.style.setProperty('--p', '1');
    h.style.opacity = 'calc(0.15 + var(--p) * 0.85)';
    h.style.transform = 'translateY(calc((1 - var(--p)) * 22px))';
    h.style.willChange = 'transform, opacity';
  });

  /* Quiet "← Swipe →" note under theme carousels' headings (opt-in by section key).
     Shown on touch phones only (CSS) and fades once the carousel is swiped. */
  var SWIPE_NOTE = ['collections_joeluxe'];
  SWIPE_NOTE.forEach(function (key) {
    var section = document.querySelector('[id$="__' + key + '"]');
    var h = section && section.querySelector('h3');
    if (!h || !section.querySelector('.resource-list__carousel') || section.querySelector('.jl-swipe-note')) return;
    var p = document.createElement('p');
    p.className = 'jl-swipe-note';
    p.setAttribute('aria-hidden', 'true');
    p.innerHTML = '<span>&larr;</span> Swipe <span>&rarr;</span>';
    h.insertAdjacentElement('afterend', p);
  });

  var els = Array.prototype.slice.call(document.querySelectorAll('[data-jl-scroll]'));
  if (!els.length) return;

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
    return; /* CSS default --p:1 shows the finished composition */
  }

  /* Defaults; a section can override with data-jl-distance / data-jl-glide,
     data-jl-mode="pin" holds on screen while it plays, data-jl-mode="top" runs
     from the top of the page (hero), data-jl-mode="end" finishes at the page bottom */
  var SCROLL_DISTANCE = 1.0; /* screens of scrolling for the full move (higher = slower) */
  var GLIDE = 0.09;          /* 0–1 per frame toward the target (lower = smoother/slower) */

  var visible = new Set();
  var state = new Map();     /* el -> { current, target } */
  var running = false;

  function targetFor(el) {
    var r = el.getBoundingClientRect();
    var vh = window.innerHeight;
    var t;
    if (state.get(el).pin) {
      /* pinned story: progress runs while the section is held on screen */
      t = -r.top / Math.max(1, r.height - vh);
    } else if (state.get(el).top) {
      /* top-of-page hero: progress runs from page top as the visitor scrolls */
      t = window.scrollY / (vh * state.get(el).distance);
    } else if (state.get(el).end) {
      /* page sign-off: finishes exactly when the page reaches its bottom */
      var left = document.documentElement.scrollHeight - window.scrollY - vh;
      t = 1 - left / (vh * state.get(el).distance);
    } else {
      t = (vh - r.top) / (vh * state.get(el).distance);
    }
    return t < 0 ? 0 : t > 1 ? 1 : t;
  }

  function ease(t) {
    return t * t * (3 - 2 * t); /* smoothstep */
  }

  function frame() {
    var moving = false;
    visible.forEach(function (el) {
      var s = state.get(el);
      s.target = targetFor(el);
      var diff = s.target - s.current;
      if (Math.abs(diff) > 0.0005) {
        s.current += diff * s.glide;
        moving = true;
      } else {
        s.current = s.target;
      }
      el.style.setProperty('--p', ease(s.current).toFixed(4));
    });
    if (moving) {
      window.requestAnimationFrame(frame);
    } else {
      running = false;
    }
  }

  function wake() {
    if (!running) {
      running = true;
      window.requestAnimationFrame(frame);
    }
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) visible.add(e.target);
      else visible.delete(e.target);
    });
    wake();
  });

  els.forEach(function (el) {
    var distance = parseFloat(el.getAttribute('data-jl-distance')) || SCROLL_DISTANCE;
    var glide = parseFloat(el.getAttribute('data-jl-glide')) || GLIDE;
    var mode = el.getAttribute('data-jl-mode');
    state.set(el, { current: 0, target: 0, distance: distance, glide: glide, pin: mode === 'pin', top: mode === 'top', end: mode === 'end' });
    var start = targetFor(el);
    state.get(el).current = start;
    state.get(el).target = start;
    el.style.setProperty('--p', ease(start).toFixed(4));
    el.classList.add('is-jl-ready');
    io.observe(el);
  });

  window.addEventListener('scroll', wake, { passive: true });
  window.addEventListener('resize', wake);
})();
